import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-avail-blocked-inter-dq-corner',
  templateUrl: './avail-blocked-inter-dq-corner.component.html',
  styleUrls: ['./avail-blocked-inter-dq-corner.component.css']
})
export class AvailBlockedInterDqCornerComponent implements OnInit {
  data: any;
  datalist: any;

  constructor(private userService: UserService) { }

  ngOnInit() {
    // console.log("In Init Method");
    this.getAvailBlockedInterDQCornerSites();
  }


  getAvailBlockedInterDQCornerSites(){
    // console.log("In ");
    this.data = this.userService.getAvailBlockedInterDQCornerSites();
    this.data.subscribe((response:any) => {
        console.log(response);
        this.datalist = response;
    },(error:any) => {
        console.log(error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/avail-blocked-inter-dq-corner/avail-blocked-inter-dq-corner.component.ts